export default __webpack_public_path__ + "static/media/dark-top.b4af7bae.webp";